<template>
  <div class="boxs">
    <ul
      class="timeline-wrapper"
      v-for="(item, index) in timelineList"
      :key="index"
    >
      <li class="timeline-item">
        <div class="timeline-box">
          <div class="out-circle">
            <img src="./images/icon.png" alt="" />
          </div>
          <div class="long-line" v-for="(it, ind) in 8" :key="ind"></div>
        </div>
        <div class="timeline-content">
          <div class="timeline-date" style="color: #f99f39">
            {{ item.timeNode }}
          </div>
          <div class="timeline-right">
            <div class="timeline-title">
              {{ item.eventName }}
            </div>
            <div class="timeline-desc">{{ item.description }}</div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "TimelineState",
  props: {
    timelineList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style scoped lang="less">
.boxs {
  position: relative;
  height: 100%;
  padding-bottom: 50px;
  .timeline-wrapper:last-child .timeline-item .timeline-box .long-line{
    width: 0px;
  }
  ul.timeline-wrapper {
    list-style: none;
    margin: 0;
    margin-top: -30px;
    margin-left: 194px;

    .box {
      margin-right: -10px;
      width: 300px;
      .box1 {
        height: 20px;
        width: 72px;
        background: linear-gradient(135deg, #6f39f4 34%, #394cf4 100%);
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
        color: #fff;
        font-size: 16px;
        text-align: center;
        line-height: 20px;
      }
      .title {
        font-size: 24px;
        color: #333;
        margin-bottom: 24px;
        font-weight: bold;
      }
    }
  }
}

/* 时间线 */
.timeline-item {
  position: relative;
  margin-top: 30px;

  .timeline-box {
    text-align: center;
    position: absolute;
    margin-top: 28px;
    .out-circle {
      position: absolute;
      top: -40px;
      left: -13px;
      width: 43px;
      height: 43px;
      .in-circle {
        width: 8px;
        height: 8px;
        margin: 0 auto;
        background: rgba(14, 116, 218, 1);
        border-radius: 50%;
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
      }
    }

    .long-line {
      width: 2px;
      height: 5px;
      background: #c8c8c8;
      margin-left: 7px;
      margin-bottom: 5px;
    }
  }

  .timeline-content {
    display: flex;
    box-sizing: border-box;
    margin-left: 20px;
    height: 106px;
    padding: 0 0 0 20px;
    text-align: left;
    .timeline-right {
      margin-left: 45px;
      width: 50%;
      .timeline-title {
        font-size: 18px;
        word-break: break-all;
        margin-bottom: 5px;
        color: #333;
        font-weight: 600;
        /*display: inline;*/
      }
      .timeline-desc {
        font-size: 12px;
        color: #333;
      }
    }
    .timeline-date {
      width: 80px;
      font-size: 16px;
      color: #999;
      font-weight: 600;
      margin-bottom: 16px;
    }
  }
}

.timeline-item:last-of-type .timeline-content {
  margin-bottom: 0;
}
</style>
